import { MonitoringTab } from '@odo/shared-ui';
import { dmScansQueryConfig } from '../../../services/patient/dmScans';

interface ScansSectionProps {
    patientId: string | null;
    dmId: number | null | undefined;
    totalAligners: number | null;
}

function ScansSection({ patientId, dmId, totalAligners }: ScansSectionProps) {
    return (
        <MonitoringTab
            queries={dmScansQueryConfig}
            patientId={patientId}
            dmId={dmId}
            allowFullscreen
            totalAligners={totalAligners}
            showIndices={false}
            showObservations={false}
        />
    );
}

export { ScansSection };
